<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ item.name }}</span>
      </v-card-title>
      <v-card-text>
        <span>Puedes cambiar el estatus de la receta para poder editarla.</span>
        <v-form ref="changeStatusRecipe" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-select
                  v-model="form.data.selectedStatus"
                  :items="status"
                  item-value="value"
                  item-text="text"
                  label="Estatus"
                  return-object
                  no-data-text="No se encontraron los estatus de las recetas"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          class="mr-4"
          rounded
          small
          @click="closeDialog('close')">
          Cerrar
        </v-btn>
        <v-btn
          color="success"
          class="mr-4"
          rounded
          small
          :disabled="!form.data.selectedStatus"
          @click="submit">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          selectedStatus: null
        }
      },
      status: [
        { value: 'in-progress', text: 'En progreso' },
        { value: 'archived', text: 'Archivar' }
      ]
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetRecipeForm()
      }
    }
  },
  methods: {
    submit: async function () {
      this.$refs.changeStatusRecipe.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          await this.$api.put(`/v1/menu/${this.item._id}`, { status: this.form.data.selectedStatus.value })
          this.$toasted.show(`Se cambió el estatus de la receta ${this.item.name}.`, { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
          this.resetRecipeForm()
          this.closeDialog('submit')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
        }
        this.overlay = false
      }
    },
    resetRecipeForm () {
      this.form.data = {
        selectedStatus: null
      }
    },
    closeDialog (event) {
      this.isOpen = false
      this.$emit(event)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
